import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import MuiTextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { Button } from '@mui/material';

import { IconWrapper } from 'components/Icon';
import { paths } from 'routes';

export const Search = ({ fullWidth = false, sx = {}, handleSearchChange, inputSx = {}, placeholder = "Search", buttonLabel = "Search", iconSx = {}, onSearchButtonClick, initialValue = '', ...other }) => {
  const [searchValue, setSearchValue] = useState(initialValue);

  const handleChange = (e) => {
    setSearchValue(e.target.value);
    if (handleSearchChange) {
      handleSearchChange(e);
    }
  };

  const handleButtonClick = () => {
    if (onSearchButtonClick) {
      onSearchButtonClick(searchValue);
    }
  };

  return (
    <MuiTextField
      placeholder={placeholder}
      fullWidth={fullWidth}
      sx={{ ...sx }}
      onChange={handleChange}
      value={searchValue}
      slotProps={{
        input: {
        startAdornment: (
          <InputAdornment position="start">
            <IconWrapper icon="search" sx={{ svg: { height: 20 }, ...iconSx }} />
          </InputAdornment>
        ),
        endAdornment: onSearchButtonClick ? (
          <InputAdornment position="end">
            <Button
                size="medium"
                variant="contained"
                onClick={handleButtonClick}
                sx={{
                  width: {xs: "auto", md: 134},
                  backgroundColor: 'primary.main',
                  '&:hover': {
                    backgroundColor: 'primary.main',
                  },
                }}
              >
                {buttonLabel}
              </Button>
          </InputAdornment>
        ) : null,
          sx: {
            pl: 2,
            pr: 1,
            height: 42,
            borderRadius: 12.5,
            '& .MuiOutlinedInput-input': {
              px: '0px!important',
            },
            ...inputSx,
        },
        }
      }}
      {...other}
    />
  );
};